import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';

import { isMobile } from 'react-device-detect';

import { GlobalStateProvider } from './context/GlobalState';
import { ThemeProvider } from './theme';

import './App.css';
import './theme/theme.css';

import OriginalLoadingScreen from './screens/OriginalLoadingScreen';
import Main from './screens/Main';
import Header from './components/Header';
import PublicHeader from './components/PublicHeader';
import Footer from './components/Footer';
import AudioPlayer from './components/AudioPlayer';
import LandingPage from './screens/LandingPage';
import Pricing from './screens/Pricing';
import AuthScreen from './screens/AuthScreen';
import VerifyEmail from './screens/VerifyEmail';
import ResetPasswordScreen from './screens/ResetPasswordScreen';

// import Terms from './screens/Terms';
// import Privacy from './screens/Privacy';
// import Contact from './screens/Contact';
// import Forgot from './screens/Forgot';
// import Redirect from './screens/Redirect';
// import Cmsui from './screens/Cmsui.js';

// Wrapper to conditionally render headers based on route
const AppContent = () => {
  const location = useLocation();
  const isAppRoute = location.pathname === '/app';

  return (
    <>
      {isAppRoute ? (
        <Header isMobile={isMobile} />
      ) : (
        <PublicHeader />
      )}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/auth" element={<AuthScreen />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPasswordScreen />} />
        <Route path="/app" element={<Main isMobile={isMobile} />} />
        <Route path="/loading" element={<OriginalLoadingScreen isMobile={isMobile} />} />
        {/* Keep the old betatest route for backward compatibility */}
        {/* <Route path="/betatest" element={<Main isMobile={isMobile} />} /> */}
        {/* <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/redirect" element={<Redirect />} />
        <Route path="/cmsui" element={<Cmsui />} /> */}
      </Routes>
      {/* <ChatWindow /> */}
      <AudioPlayer />
      {!isAppRoute && <Footer isMobile={isMobile} />}
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <GlobalStateProvider>
        <div className="App" style={{ position: 'relative' }}>
          <Router>
            <AppContent />
          </Router>
        </div>
      </GlobalStateProvider>
    </ThemeProvider>
  );
}

export default App;
